import { getDownloadURL as firebaseGetDownloadURL } from "firebase/storage";
import { mergeWithNavigationSignal } from "@/utils/navigationAbort";

function abortError() {
  const e = new Error("Request aborted");
  e.name = "AbortError";
  e.code = "ERR_CANCELED";
  return e;
}

/**
 * Firebase Storage `getDownloadURL` 래퍼.
 * Vue 라우트가 바뀌면 이전 화면에서 시작한 호출은 결과를 버리고 AbortError로 reject.
 *
 * 참고: Firebase JS SDK가 내부 XHR을 즉시 중단하지 않을 수 있음(브라우저마다 다름).
 * UI 상태 오염 방지와 불필요한 후속 처리 생략이 주 목적.
 *
 * @param {import('firebase/storage').StorageReference} storageRef
 * @param {AbortSignal} [existingSignal] 추가로 함께 감시할 signal (선택)
 */
export async function getDownloadURL(storageRef, existingSignal) {
  const signal = mergeWithNavigationSignal(existingSignal);

  return new Promise((resolve, reject) => {
    if (signal.aborted) {
      reject(abortError());
      return;
    }

    const onAbort = () => {
      signal.removeEventListener("abort", onAbort);
      reject(abortError());
    };
    signal.addEventListener("abort", onAbort, { once: true });

    firebaseGetDownloadURL(storageRef)
      .then((url) => {
        signal.removeEventListener("abort", onAbort);
        if (signal.aborted) {
          reject(abortError());
          return;
        }
        resolve(url);
      })
      .catch((err) => {
        signal.removeEventListener("abort", onAbort);
        reject(err);
      });
  });
}
